module.exports = __webpack_public_path__ + "static/media/tutorial1.749884e0.svg";